module.exports = __webpack_public_path__ + "img/base_activites_croisiere.1b3e0d19.svg";